const error = {
    status: 'error',
    message: 'Хүсэлт илгээхэд алдаа гарлаа. Та дахин оролдоно уу.',
    info: ''
};

const getInfoRespError = (errors) => {
    let msg = error.message;
    if (errors.data) {
        if (errors.data.message) {
            msg = errors.data.message;
        } else {
            if (typeof errors.data === 'string') {
                msg = errors.data;
            } else {
                msg = JSON.stringify(errors.data);
            }
        }
    }
    return msg;
}

/**
 * Form дэлгэц дээр Validation тодорхойлох function
 * @param  {object} values
 * @param  {object} validations
 * @param  {translate function} t
 * example:
 * values = {rn: '19', roleid: 50, rolename: '', rolenameeng: '1', status: 1}
 * validation = {rolename: {required: true, maxLength: 30,title: t('dashboard.role.rolename')},rolenameeng: {}}
 * return msg = 'rolname талбар хоосон'
 */
export const formValidationFunc = (values, validations, t) => {
    const msg = {};
    for (const field in validations) {
        const fieldValids = validations[field];
        /**
         * талбар хоосон утга зөвшөөрөх эсэхийг шалгана.
         * @param  {boolean} fieldValids.required
         */
        if (fieldValids.required) {
            if (!values[field]) {
                if (fieldValids.type === "numeric")
                    msg[field] = `${fieldValids.title ? fieldValids.title : ''} ${t('validation.mustNotNull')}`
                else {
                    if (values[field] !== 0) {
                        msg[field] = `${fieldValids.title ? fieldValids.title : ''} ${t('validation.mustNotNull')}`
                    }
                }
            }
        }

        /**
         * талбарын утгын уртыг шалгана.
         * @param  {number} fieldValids.maxLength
         */
        if (fieldValids.maxLength) {
            if (values[field] && values[field].length > fieldValids.maxLength) {
                msg[field] = `${fieldValids.title ? fieldValids.title : ''} ${t('validation.notValidMaxLength')} ${values[field].length}/${fieldValids.maxLength}`
            }
        }

        /**
         * талбарын утгын бага утгыг шалгана.
         * @param  {number} fieldValids.min
         */
        if (fieldValids.min || fieldValids.min === 0) {
            if (values[field] && values[field] < fieldValids.min) {
                msg[field] = `${fieldValids.title ? fieldValids.title : ''} ${t('validation.notValidMinimum')}`
            }
        }

        /**
         * Validator
         */
        if (fieldValids.validators) {
            if (values[field]) {
                for (let index = 0; index < fieldValids.validators.length; index++) {
                    const element = fieldValids.validators[index];
                    if (!element.test(values[field])) {
                        msg[field] = `${fieldValids.title ? fieldValids.title : ''} ${t('validation.not_validator')}`;
                    }
                }
            }
        }
    }
    // for (const property in values) {
    //     if (validations[property]) {
    //         const fieldValids = validations[property];
    //         /**
    //          * талбар хоосон утга зөвшөөрөх эсэхийг шалгана.
    //          * @param  {boolean} fieldValids.required
    //          */
    //         if (fieldValids.required) {
    //             if (!values[property]) {
    //                 msg[property] = `${fieldValids.title ? fieldValids.title : ''} ${t('validation.mustNotNull')}`
    //             }
    //         }

    //         /**
    //          * талбарын утгын уртыг шалгана.
    //          * @param  {number} fieldValids.maxLength
    //          */
    //         if (fieldValids.maxLength) {
    //             if (values[property] && values[property].length > fieldValids.maxLength) {
    //                 msg[property] = `${fieldValids.title ? fieldValids.title : ''} ${t('validation.notValidMaxLength')} ${values[property].length}/${fieldValids.maxLength}`
    //             }
    //         }
    //     }
    // }
    return msg;
}

const functions = {
    getInfoRespError,
    error,
};

export default functions;

// Нууц үгийн полиси шалгах
export const checkPassPolicy = (password, policies) => {
    if (policies && policies.length > 0) {
        const tmpPolicy = {};
        for (let index = 0; index < policies.length; index++) {
            const element = policies[index];
            tmpPolicy[element.optionname] = element.optionvalue;
        }

        if (!password) {
            return 'Нууц үг оруулна уу';
        }

        if (password.length > Number(tmpPolicy['PassHighLength'])) {
            return `Нууц үгийн урт хэтэрсэн байна. ${tmpPolicy['PassHighLength']}/${password.length}`
        }

        if (password.length < Number(tmpPolicy['PassLowLength'])) {
            return `Нууц үг хамгийн багадаа ${tmpPolicy['PassLowLength']} байна.`
        }

        if (Number(tmpPolicy['MustUpperLetter']) === 1) {
            const medRegex = new RegExp(`^(?=.*[${tmpPolicy['UpperLetter']}])`)
            if (!medRegex.test(password)) {
                return `Том үсэг оруулна уу. /${tmpPolicy['UpperLetter']}/`
            }
        }

        if (Number(tmpPolicy['MustLowerLetter']) === 1) {
            const medRegex = new RegExp(`^(?=.*[${tmpPolicy['LowerLetter']}])`)
            if (!medRegex.test(password)) {
                return `Жижиг үсэг оруулна уу.`
            }
        }

        if (Number(tmpPolicy['MustPunctuation']) === 1) {
            const medRegex = new RegExp(`^(?=.*[${tmpPolicy['Punctuation']}])`)
            if (!medRegex.test(password)) {
                return `Тусгай тэмдэгт оруулна уу. /${tmpPolicy['Punctuation']}/`
            }
        }

        if (Number(tmpPolicy['MustNumber']) === 1) {
            const medRegex = new RegExp(`^(?=.*[${tmpPolicy['Numbers']}])`)
            if (!medRegex.test(password)) {
                return `Тоо оруулна уу.`
            }
        }
    }
}

export const dateFormat = (date, isTime = false) => {
    if (date) {
        const d = new Date(date);
        let dateS = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
        if (isTime) {
            dateS = `${dateS} ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}:${("0" + d.getSeconds()).slice(-2)}`;
        }
        return dateS;
    } else {
        return null;
    }
};

export const getDateFormatTime = (date) => {
    if (date) {
        const d = new Date(date);
        let dateS = `${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}:${("0" + d.getSeconds()).slice(-2)}`;

        return dateS;
    } else {
        return null;
    }
};

export const password_validator = (value) => {
    if (!value) return '';
    if (!/.{8,}/.test(value)) return "Нууц үг хамгийн багадаа 8 урттай байна.";
    if (!/[a-z]/.test(value)) return "Жижиг үсэг оруулна уу.";
    if (!/[A-Z]/.test(value)) return "Том үсэг оруулна уу.";
    if (!/[0-9]/.test(value)) return "Тоо оруулна уу.";
    if (!/[!@#$%^&*()\-/_+.]/.test(value)) return "Тусгай тэмдэгт оруулна уу.";
    return '';
};

export const password_confirmation_validator = (value, valueGetter) => {
    if (!value) return '';
    if (valueGetter("password") !== value) return "Нууц үг таарсангүй..";
    return '';
};

/**
 * 
 * @param {Array} arr1 
 * @param {Array} arr2 
 * @returns array
 * erembelegdsen 2 array-n adil elementuudiig olood butsaana
 */
export const findDuplicatesSorted = (arr1, arr2) => {

    const duplicates = [];
    let i = 0;
    let j = 0;

    while (i < arr1.length && j < arr2.length) {
        if (arr1[i] === arr2[j]) {
            duplicates.push(arr1[i]);
            i++;
            j++;
        } else if (arr1[i] < arr2[j]) {
            i++;
        } else {
            j++;
        }
    }

    return duplicates;
}

export function roundTo(num, decimalPlaces) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(num * factor) / factor;
}

/**
 * 
 * @param {Array} mainArray 
 * @param {Array} subArray 
 * @returns Array
 * neg ni nuguugiinhuu ded olonlog boldog erembelegdsen 2 array-n ylgaag butsaana
 */
export const removeSubarraySorted = (mainArray, subArray) => {
    let i = 0;
    let j = 0;

    while (i < mainArray.length && j < subArray.length) {
        if (mainArray[i] === subArray[j]) {
            mainArray.splice(i, 1); // Remove the matching element from mainArray
            j++; // Move to the next element in subArray
        } else {
            i++; // Move to the next element in mainArray
        }
    }

    return mainArray;
}

// utils/ibanMn.js

function zpad(v, len) {
    return String(v ?? "").replace(/\s+/g, "").padStart(len, "0");
}

function ibanToNumeric(s) {
    s = s.toUpperCase();
    let out = "";
    for (const ch of s) {
        if (ch >= "0" && ch <= "9") out += ch;
        else if (ch >= "A" && ch <= "Z") out += String(ch.charCodeAt(0) - 55); // A=10
        else if (/[\u0400-\u04FF]/.test(ch)) throw new Error("Cyrillic character detected: " + ch);
        else throw new Error("Invalid IBAN char: " + ch);
    }
    return out;
}

function mod97(numStr) {
    let rem = 0;
    for (let i = 0; i < numStr.length; i++) rem = (rem * 10 + (numStr.charCodeAt(i) - 48)) % 97;
    return rem;
}

/**
 * Convert A-Z to 10-35; digits stay digits.
 * Example: "MN00AB12" -> "222300101112"
 */
function ibanToNumericString(iban) {
    const up = iban.toUpperCase();
    let out = "";
    for (const ch of up) {
        const code = ch.charCodeAt(0);
        if (ch >= "0" && ch <= "9") out += ch;
        else if (code >= 65 && code <= 90) out += String(code - 55); // A=10 ... Z=35
        else throw new Error(`Invalid character in IBAN: "${ch}"`);
    }
    return out;
}

export function generateMnIban(bankCode, accountNo) {
    const bank = zpad(bankCode, 4);     // 0004
    const acc = zpad(accountNo, 12);   // 000452229809  (12 орон!)
    const bban = bank + acc;            // нийт 16

    const numeric = ibanToNumeric(bban + "MN00");
    const check = String(98 - mod97(numeric)).padStart(2, "0");

    return "MN" + check + bban;         // нийт 20 тэмдэгт
}

/**
 * Validate any IBAN (including MN)
 */
export function validateIban(iban) {
    const clean = String(iban ?? "").replace(/\s+/g, "").toUpperCase();
    if (clean.length < 5) return false;
    const rearranged = clean.slice(4) + clean.slice(0, 4);
    const numeric = ibanToNumericString(rearranged);
    return mod97(numeric) === 1;
}

/**
 * Pretty print: groups of 4
 */
export function formatIban(iban) {
    const s = String(iban ?? "").replace(/\s+/g, "").toUpperCase();
    return s.replace(/(.{4})/g, "$1 ").trim();
}
